import { render, staticRenderFns } from "./FindPositionOfCustomer.vue?vue&type=template&id=0d8505a5"
import script from "./FindPositionOfCustomer.vue?vue&type=script&lang=js"
export * from "./FindPositionOfCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports